import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-fatura-olusturuldu',
  templateUrl: './fatura-olusturuldu.component.html',
  styleUrls: ['./fatura-olusturuldu.component.css']
})
export class FaturaOlusturulduComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  faturaId: string = null;

  constructor(private route: ActivatedRoute,
    private router: Router) { }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.faturaId = params.id;
    }));
  }

  showFaturalar() {
    this.router.navigate(['faturalar']);
  }

  newFatura() {
    this.router.navigate(['fatura'], { queryParams: { id: '0' } });
  }
}
